var map = {
	"./collectionByAccountWithTokens.graphql": [
		2877,
		191
	],
	"./collectionCuratedList.graphql": [
		2878,
		192
	],
	"./fragments/baseMeta.graphql": [
		2870,
		193
	],
	"./fragments/collection.graphql": [
		2865,
		194
	],
	"./fragments/collectionDetails.graphql": [
		2869,
		195
	],
	"./fragments/collectionMeta.graphql": [
		2867,
		196
	],
	"./fragments/event.graphql": [
		2866,
		197
	],
	"./fragments/nft.graphql": [
		2864,
		198
	],
	"./fragments/nftDetails.graphql": [
		2863,
		199
	],
	"./fragments/nftEmotes.graphql": [
		2879,
		200
	],
	"./fragments/nftSubsquid.graphql": [
		2871,
		201
	],
	"./fragments/subsquidNft.graphql": [
		2868,
		202
	],
	"./nftSimpleListByAccount.graphql": [
		856,
		170
	],
	"./profileStatsById.graphql": [
		2880,
		168
	],
	"./rmrk/subsquid/allCollectionSaleEvents.graphql": [
		2881,
		177
	],
	"./rmrk/subsquid/allEventsByProfile.graphql": [
		771,
		203
	],
	"./rmrk/subsquid/allNftSaleEventsByAccountId.graphql": [
		549,
		204
	],
	"./rmrk/subsquid/allNftSaleEventsHistoryByAccountId.graphql": [
		550,
		178
	],
	"./rmrk/subsquid/collectionBuyEventStatsById.graphql": [
		2882,
		205
	],
	"./rmrk/subsquid/collectionChartById.graphql": [
		2883,
		206
	],
	"./rmrk/subsquid/collectionListByAccount.graphql": [
		866,
		158
	],
	"./rmrk/subsquid/collectionSeriesList.graphql": [
		2884,
		207
	],
	"./rmrk/subsquid/collectionSpotlightList.graphql": [
		2885,
		208
	],
	"./rmrk/subsquid/collectionsEvents.graphql": [
		855,
		209
	],
	"./rmrk/subsquid/hotNfts.graphql": [
		853,
		210
	],
	"./rmrk/subsquid/lastNftListByEvent.graphql": [
		2886,
		211
	],
	"./rmrk/subsquid/nftByIdMinimal.graphql": [
		850,
		212
	],
	"./rmrk/subsquid/passionFeed.graphql": [
		2887,
		213
	],
	"./rmrk/subsquid/recentSalesForCreator.graphql": [
		615,
		214
	],
	"./rmrk/subsquid/salesFeed.graphql": [
		854,
		215
	],
	"./rmrk/subsquid/seriesInsightList.graphql": [
		540,
		216
	],
	"./rmrk/subsquid/spotlightList.graphql": [
		863,
		217
	],
	"./rmrk/subsquid/spotlightSoldHistory.graphql": [
		864,
		218
	],
	"./subsquid/bsx/acceptableOfferByCurrentOwner.graphql": [
		694,
		219
	],
	"./subsquid/bsx/acceptableOfferListByNftId.graphql": [
		2888,
		220
	],
	"./subsquid/bsx/allCollectionSaleEvents.graphql": [
		868,
		179
	],
	"./subsquid/bsx/assetById.graphql": [
		869,
		221
	],
	"./subsquid/bsx/assetList.graphql": [
		778
	],
	"./subsquid/bsx/assetListByIdList.graphql": [
		870,
		222
	],
	"./subsquid/bsx/collectionActivityEvents.graphql": [
		2889,
		223
	],
	"./subsquid/bsx/itemEvents.graphql": [
		2890,
		180
	],
	"./subsquid/bsx/notificationsByAccount.graphql": [
		2891,
		183
	],
	"./subsquid/bsx/offerHighest.graphql": [
		2892,
		224
	],
	"./subsquid/bsx/offerList.graphql": [
		871,
		225
	],
	"./subsquid/bsx/offerListByCollectionId.graphql": [
		872,
		226
	],
	"./subsquid/bsx/offerListByNftId.graphql": [
		2893,
		227
	],
	"./subsquid/bsx/offerListUser.graphql": [
		551,
		228
	],
	"./subsquid/bsx/statsForBsx.graphql": [
		873,
		229
	],
	"./subsquid/general/buyEventByProfile.graphql": [
		2894,
		230
	],
	"./subsquid/general/collectionActivityEvents.graphql": [
		2895,
		231
	],
	"./subsquid/general/collectionBurnableStats.graphql": [
		2896,
		232
	],
	"./subsquid/general/collectionBuyEventStatsById.graphql": [
		2897,
		233
	],
	"./subsquid/general/collectionByAccount.graphql": [
		2898,
		234
	],
	"./subsquid/general/collectionById.graphql": [
		2899,
		145
	],
	"./subsquid/general/collectionByIdMicro.graphql": [
		2900,
		235
	],
	"./subsquid/general/collectionByIdMinimal.graphql": [
		2901,
		236
	],
	"./subsquid/general/collectionByIds.graphql": [
		2902,
		237
	],
	"./subsquid/general/collectionCuratedList.graphql": [
		2903,
		159
	],
	"./subsquid/general/collectionEntityById.graphql": [
		2904,
		151
	],
	"./subsquid/general/collectionForMint.graphql": [
		2905,
		238
	],
	"./subsquid/general/collectionLastList.graphql": [
		2906,
		160
	],
	"./subsquid/general/collectionListWithSearch.graphql": [
		865,
		161
	],
	"./subsquid/general/collectionMintedBetween.graphql": [
		2907,
		239
	],
	"./subsquid/general/collectionStatsById.graphql": [
		2908,
		240
	],
	"./subsquid/general/collectionStatsByIdWithOffers.graphql": [
		2909,
		241
	],
	"./subsquid/general/collectionsSales.graphql": [
		2910,
		242
	],
	"./subsquid/general/dropCollectionById.graphql": [
		2911,
		243
	],
	"./subsquid/general/eventListByNftId.graphql": [
		2912,
		181
	],
	"./subsquid/general/existingCollectionList.graphql": [
		2913,
		244
	],
	"./subsquid/general/firstNftByIssuer.graphql": [
		867,
		245
	],
	"./subsquid/general/firstNftOwnedByAccountAndCollectionId.graphql": [
		2914,
		246
	],
	"./subsquid/general/itemEvents.graphql": [
		2915,
		182
	],
	"./subsquid/general/lastNftListByEvent.graphql": [
		2916,
		247
	],
	"./subsquid/general/nftById.graphql": [
		2917,
		171
	],
	"./subsquid/general/nftByIdWithoutRoyalty.graphql": [
		2918,
		172
	],
	"./subsquid/general/nftEntitiesByIDs.graphql": [
		2919,
		152
	],
	"./subsquid/general/nftIdListByCollection.graphql": [
		2920,
		248
	],
	"./subsquid/general/nftListByIssuer.graphql": [
		772,
		154
	],
	"./subsquid/general/nftListByIssuerAndOwner.graphql": [
		2921,
		249
	],
	"./subsquid/general/nftListCollected.graphql": [
		773,
		155
	],
	"./subsquid/general/nftListSold.graphql": [
		774,
		156
	],
	"./subsquid/general/nftListSoldByCollection.graphql": [
		2922,
		157
	],
	"./subsquid/general/nftListWithSearch.graphql": [
		2923,
		148
	],
	"./subsquid/general/nftListedCountByCollection.graphql": [
		2924,
		250
	],
	"./subsquid/general/nftOwnedCountByCollectionId.graphql": [
		2925,
		251
	],
	"./subsquid/general/notificationsByAccount.graphql": [
		2926,
		184
	],
	"./subsquid/general/popularCollectionList.graphql": [
		2927,
		252
	],
	"./subsquid/general/profileStatsById.graphql": [
		2928,
		169
	],
	"./subsquid/general/topCollectionList.graphql": [
		2929,
		253
	],
	"./subsquid/general/unlockableCollectionById.graphql": [
		2930,
		146
	],
	"./subsquid/general/userStatsByAccount.graphql": [
		2931,
		254
	],
	"./subsquid/ksm/collectionEntityById.graphql": [
		2932,
		153
	],
	"./subsquid/ksm/nftById.graphql": [
		2933,
		149
	],
	"./subsquid/ksm/nftListWithSearch.graphql": [
		2934,
		150
	],
	"./subsquid/rmrk/collectionForMint.graphql": [
		874,
		255
	],
	"./subsquid/rmrk/collectionStatsById.graphql": [
		2935,
		256
	],
	"./subsquid/rmrk/nftById.graphql": [
		2936,
		173
	],
	"./subsquid/rmrk/usedCollectionSymbolsByAccount.graphql": [
		875,
		257
	],
	"./subsquid/stmn/nftById.graphql": [
		2937,
		174
	],
	"./unique/collectionById.graphql": [
		2938,
		162
	],
	"./unique/collectionForMint.graphql": [
		2939,
		258
	],
	"./unique/collectionListByAccount.graphql": [
		2940,
		175
	],
	"./unique/collectionListWithSearch.graphql": [
		2941,
		176
	],
	"./unique/existingCollectionList.graphql": [
		2942,
		259
	],
	"./unique/firstNftByIssuer.graphql": [
		2943,
		260
	],
	"./unique/nftById.graphql": [
		2944,
		163
	],
	"./unique/nftListByIssuer.graphql": [
		2945,
		164
	],
	"./unique/nftListCollected.graphql": [
		2946,
		165
	],
	"./unique/nftListSold.graphql": [
		2947,
		166
	],
	"./unique/nftListWithSearch.graphql": [
		2948,
		167
	],
	"./unique/nftStatsByIssuer.graphql": [
		2949,
		261
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1933;
module.exports = webpackAsyncContext;